// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ✅ MaterielReparationsPage */

.mr-page {
  color: var(--color-dark-brown, #3d2b1f);
  font-size: 0.875rem;
}

/* ── Header ── */
.mr-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 16px;
}

.mr-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.mr-header-icon {
  font-size: 1.6rem;
  color: #6d4e36;
  opacity: 0.8;
}

.mr-header-title {
  font-size: 1.25rem;
  font-weight: 800;
  color: #3d2b1f;
  line-height: 1.2;
}

.mr-header-sub {
  font-size: 0.75rem;
  color: #9e8878;
  margin-top: 2px;
}

/* ── KPI cards ── */
.mr-kpi-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  margin-bottom: 16px;
}

@media (max-width: 900px) {
  .mr-kpi-row { grid-template-columns: repeat(2, 1fr); }
}

@media (max-width: 480px) {
  .mr-kpi-row { grid-template-columns: 1fr 1fr; }
}

.mr-kpi-card {
  background: #fff;
  border-radius: 12px;
  border: 1px solid rgba(109, 78, 54, 0.12);
  padding: 12px 14px;
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
}

.mr-kpi-icon {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.mr-kpi-value {
  font-size: 1.25rem;
  font-weight: 900;
  line-height: 1;
}

.mr-kpi-label {
  font-size: 0.7rem;
  color: #9e8878;
  margin-top: 3px;
}

.mr-kpi-sub {
  font-size: 0.68rem;
  color: #bbb;
  margin-top: 2px;
}

/* ── Filters ── */
.mr-filters {
  background: #fdfcf8;
  border: 1px solid rgba(109, 78, 54, 0.13);
  border-radius: 12px;
  padding: 14px 16px;
  margin-bottom: 14px;
}

.mr-filters-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.mr-filters-title {
  font-size: 0.72rem;
  font-weight: 700;
  color: #9e8878;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.mr-reset-btn {
  background: none;
  border: 1px solid rgba(109, 78, 54, 0.2);
  border-radius: 7px;
  color: #9e8878;
  font-size: 0.72rem;
  font-weight: 600;
  padding: 3px 10px;
  cursor: pointer;
  transition: all 0.15s;
}

.mr-reset-btn:hover {
  background: rgba(109, 78, 54, 0.07);
  color: #6d4e36;
  border-color: rgba(109, 78, 54, 0.35);
}

.mr-filter-label {
  font-size: 0.72rem;
  font-weight: 600;
  color: #7a6a5c;
  margin-bottom: 3px;
}

.flex-1 { flex: 1 1; }

/* ── Toolbar ── */
.mr-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 10px;
}

.mr-search-wrap {
  position: relative;
  flex: 1 1 280px;
  max-width: 420px;
}

.mr-search-icon {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #b0a090;
  font-size: 12px;
  pointer-events: none;
}

.mr-search-input {
  width: 100%;
  padding: 7px 30px 7px 30px;
  border: 1.5px solid rgba(109, 78, 54, 0.18);
  border-radius: 10px;
  font-size: 0.82rem;
  color: #3d2b1f;
  background: #fff;
  outline: none;
  transition: border-color 0.2s;
}

.mr-search-input:focus {
  border-color: rgba(109, 78, 54, 0.4);
  box-shadow: 0 0 0 3px rgba(109, 78, 54, 0.07);
}

.mr-search-clear {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #b0a090;
  cursor: pointer;
  font-size: 12px;
  padding: 2px;
}

.mr-search-clear:hover { color: #6d4e36; }

.mr-pagination-controls {
  display: flex;
  align-items: center;
  gap: 10px;
}

.mr-count {
  font-size: 0.75rem;
  color: #9e8878;
  white-space: nowrap;
}

/* ── Table wrapper ── */
.mr-table-wrap {
  overflow-x: auto;
  border-radius: 12px;
  border: 1px solid rgba(109, 78, 54, 0.13);
  background: #fff;
  box-shadow: 0 2px 10px rgba(0,0,0,0.04);
}

/* ── Table ── */
.mr-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.82rem;
}

.mr-th {
  background: #f9f7f3;
  color: #6d4e36;
  font-weight: 700;
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  padding: 10px 10px;
  border-bottom: 2px solid rgba(109, 78, 54, 0.12);
  cursor: pointer;
  white-space: nowrap;
  -webkit-user-select: none;
          user-select: none;
  transition: background 0.15s;
}

.mr-th:hover { background: #f0ece4; }
.mr-th-active { background: #ede8df !important; }
.mr-th-exp { width: 24px; padding: 10px 6px; }
.mr-sort-arrow { font-size: 0.65rem; opacity: 0.5; }

.mr-table td {
  padding: 9px 10px;
  border-bottom: 1px solid rgba(109, 78, 54, 0.07);
  vertical-align: middle;
}

.mr-row {
  cursor: pointer;
  transition: background 0.12s;
}

.mr-row:hover { background: #faf8f4; }
.mr-row-expanded { background: #f5f2ec !important; }

.mr-td-exp {
  color: #b0a090;
  text-align: center;
  width: 24px;
}

.mr-td-muted { color: #9e8878; font-size: 0.78rem; }
.mr-td-num { text-align: right; font-variant-numeric: tabular-nums; }

/* Matériel cell */
.mr-mat-cell {
  display: flex;
  align-items: center;
  gap: 5px;
  flex-wrap: wrap;
}

.mr-mat-id {
  font-size: 0.68rem;
  font-weight: 700;
  color: #b0a090;
  background: rgba(109, 78, 54, 0.07);
  border-radius: 4px;
  padding: 1px 5px;
}

.mr-mat-matricule {
  font-weight: 800;
  color: #3d2b1f;
  font-size: 0.82rem;
}

.mr-mat-type {
  font-size: 0.62rem !important;
  padding: 1px 5px !important;
}

.mr-mat-soc {
  font-size: 0.68rem;
  color: #b0a090;
  margin-top: 1px;
}

/* Ref BDC */
.mr-ref-bdc {
  font-size: 0.73rem;
  font-weight: 700;
  color: #4527a0;
  background: rgba(69, 39, 160, 0.07);
  border-radius: 5px;
  padding: 2px 7px;
}

/* Fournisseur */
.mr-td-fournisseur {
  font-size: 0.78rem;
  color: #3d2b1f;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Designation */
.mr-designation {
  font-weight: 600;
  color: #3d2b1f;
  line-height: 1.3;
}

.mr-code {
  font-size: 0.67rem;
  color: #b0a090;
  margin-top: 2px;
  font-family: monospace;
}

.mr-unite {
  font-size: 0.68rem;
  color: #b0a090;
}

.mr-ttc {
  font-weight: 800;
  color: #1565c0;
}

/* ── Expanded row ── */
.mr-row-detail td {
  padding: 0 !important;
  background: #f8f6f1;
}

.mr-expand {
  padding: 14px 18px 16px;
  border-bottom: 2px solid rgba(109, 78, 54, 0.1);
}

.mr-expand-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 12px;
}

.mr-expand-section {
  background: #fff;
  border-radius: 10px;
  border: 1px solid rgba(109, 78, 54, 0.1);
  padding: 10px 12px;
}

.mr-expand-comment {
  grid-column: 1 / -1;
}

.mr-expand-title {
  font-size: 0.67rem;
  font-weight: 700;
  color: #9e8878;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 5px;
}

.mr-expand-rows {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 4px 10px;
  align-items: start;
}

.mr-exp-label {
  font-size: 0.7rem;
  color: #b0a090;
  white-space: nowrap;
  padding-top: 1px;
}

.mr-exp-val {
  font-size: 0.78rem;
  font-weight: 600;
  color: #3d2b1f;
  word-break: break-word;
}

.mr-exp-comment-body {
  font-size: 0.78rem;
  color: #5a4a3a;
  line-height: 1.5;
  white-space: pre-wrap;
}

/* ── Footer total ── */
.mr-foot td {
  background: #f5f2ec;
  border-top: 2px solid rgba(109, 78, 54, 0.15);
  border-bottom: none;
}

.mr-foot-label {
  font-size: 0.72rem;
  font-weight: 700;
  color: #9e8878;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.mr-foot-ttc {
  font-size: 0.92rem;
  font-weight: 900;
  color: #1565c0;
  text-align: right;
}

/* ── Empty state ── */
.mr-empty {
  text-align: center;
  padding: 3rem;
  color: #b0a090;
  font-size: 0.9rem;
}

/* ── Pagination ── */
.mr-pager {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  margin-top: 16px;
  flex-wrap: wrap;
}

.mr-pg-btn {
  min-width: 32px;
  height: 32px;
  padding: 0 8px;
  border: 1.5px solid rgba(109, 78, 54, 0.18);
  border-radius: 8px;
  background: #fff;
  color: #6d4e36;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
}

.mr-pg-btn:hover:not(:disabled) {
  background: #f5f0e8;
  border-color: rgba(109, 78, 54, 0.35);
}

.mr-pg-btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.mr-pg-active {
  background: #6d4e36 !important;
  color: #fff !important;
  border-color: #6d4e36 !important;
  font-weight: 800 !important;
}

.mr-pg-ellipsis {
  color: #b0a090;
  padding: 0 4px;
  font-size: 0.82rem;
}
`, "",{"version":3,"sources":["webpack://./src/styles/MaterielReparationsPage.css"],"names":[],"mappings":"AAAA,8BAA8B;;AAE9B;EACE,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc,qCAAqC,EAAE;AACvD;;AAEA;EACE,cAAc,8BAA8B,EAAE;AAChD;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,yCAAyC;EACzC,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA,UAAU,SAAO,EAAE;;AAEnB,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,YAAY;AACd;;AAEA,yBAAyB,cAAc,EAAE;;AAEzC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,gDAAgD;EAChD,eAAe;EACf,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA,eAAe,mBAAmB,EAAE;AACpC,gBAAgB,8BAA8B,EAAE;AAChD,aAAa,WAAW,EAAE,iBAAiB,EAAE;AAC7C,iBAAiB,kBAAkB,EAAE,YAAY,EAAE;;AAEnD;EACE,iBAAiB;EACjB,gDAAgD;EAChD,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA,gBAAgB,mBAAmB,EAAE;AACrC,mBAAmB,8BAA8B,EAAE;;AAEnD;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;;AAEA,eAAe,cAAc,EAAE,kBAAkB,EAAE;AACnD,aAAa,iBAAiB,EAAE,kCAAkC,EAAE;;AAEpE,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB","sourcesContent":["/* ✅ MaterielReparationsPage */\r\n\r\n.mr-page {\r\n  color: var(--color-dark-brown, #3d2b1f);\r\n  font-size: 0.875rem;\r\n}\r\n\r\n/* ── Header ── */\r\n.mr-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  flex-wrap: wrap;\r\n  gap: 1rem;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.mr-header-left {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n}\r\n\r\n.mr-header-icon {\r\n  font-size: 1.6rem;\r\n  color: #6d4e36;\r\n  opacity: 0.8;\r\n}\r\n\r\n.mr-header-title {\r\n  font-size: 1.25rem;\r\n  font-weight: 800;\r\n  color: #3d2b1f;\r\n  line-height: 1.2;\r\n}\r\n\r\n.mr-header-sub {\r\n  font-size: 0.75rem;\r\n  color: #9e8878;\r\n  margin-top: 2px;\r\n}\r\n\r\n/* ── KPI cards ── */\r\n.mr-kpi-row {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, 1fr);\r\n  gap: 12px;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n@media (max-width: 900px) {\r\n  .mr-kpi-row { grid-template-columns: repeat(2, 1fr); }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .mr-kpi-row { grid-template-columns: 1fr 1fr; }\r\n}\r\n\r\n.mr-kpi-card {\r\n  background: #fff;\r\n  border-radius: 12px;\r\n  border: 1px solid rgba(109, 78, 54, 0.12);\r\n  padding: 12px 14px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  box-shadow: 0 2px 8px rgba(0,0,0,0.04);\r\n}\r\n\r\n.mr-kpi-icon {\r\n  width: 38px;\r\n  height: 38px;\r\n  border-radius: 10px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.mr-kpi-value {\r\n  font-size: 1.25rem;\r\n  font-weight: 900;\r\n  line-height: 1;\r\n}\r\n\r\n.mr-kpi-label {\r\n  font-size: 0.7rem;\r\n  color: #9e8878;\r\n  margin-top: 3px;\r\n}\r\n\r\n.mr-kpi-sub {\r\n  font-size: 0.68rem;\r\n  color: #bbb;\r\n  margin-top: 2px;\r\n}\r\n\r\n/* ── Filters ── */\r\n.mr-filters {\r\n  background: #fdfcf8;\r\n  border: 1px solid rgba(109, 78, 54, 0.13);\r\n  border-radius: 12px;\r\n  padding: 14px 16px;\r\n  margin-bottom: 14px;\r\n}\r\n\r\n.mr-filters-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.mr-filters-title {\r\n  font-size: 0.72rem;\r\n  font-weight: 700;\r\n  color: #9e8878;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.06em;\r\n}\r\n\r\n.mr-reset-btn {\r\n  background: none;\r\n  border: 1px solid rgba(109, 78, 54, 0.2);\r\n  border-radius: 7px;\r\n  color: #9e8878;\r\n  font-size: 0.72rem;\r\n  font-weight: 600;\r\n  padding: 3px 10px;\r\n  cursor: pointer;\r\n  transition: all 0.15s;\r\n}\r\n\r\n.mr-reset-btn:hover {\r\n  background: rgba(109, 78, 54, 0.07);\r\n  color: #6d4e36;\r\n  border-color: rgba(109, 78, 54, 0.35);\r\n}\r\n\r\n.mr-filter-label {\r\n  font-size: 0.72rem;\r\n  font-weight: 600;\r\n  color: #7a6a5c;\r\n  margin-bottom: 3px;\r\n}\r\n\r\n.flex-1 { flex: 1; }\r\n\r\n/* ── Toolbar ── */\r\n.mr-toolbar {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  flex-wrap: wrap;\r\n  gap: 10px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.mr-search-wrap {\r\n  position: relative;\r\n  flex: 1 1 280px;\r\n  max-width: 420px;\r\n}\r\n\r\n.mr-search-icon {\r\n  position: absolute;\r\n  left: 10px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  color: #b0a090;\r\n  font-size: 12px;\r\n  pointer-events: none;\r\n}\r\n\r\n.mr-search-input {\r\n  width: 100%;\r\n  padding: 7px 30px 7px 30px;\r\n  border: 1.5px solid rgba(109, 78, 54, 0.18);\r\n  border-radius: 10px;\r\n  font-size: 0.82rem;\r\n  color: #3d2b1f;\r\n  background: #fff;\r\n  outline: none;\r\n  transition: border-color 0.2s;\r\n}\r\n\r\n.mr-search-input:focus {\r\n  border-color: rgba(109, 78, 54, 0.4);\r\n  box-shadow: 0 0 0 3px rgba(109, 78, 54, 0.07);\r\n}\r\n\r\n.mr-search-clear {\r\n  position: absolute;\r\n  right: 8px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  background: none;\r\n  border: none;\r\n  color: #b0a090;\r\n  cursor: pointer;\r\n  font-size: 12px;\r\n  padding: 2px;\r\n}\r\n\r\n.mr-search-clear:hover { color: #6d4e36; }\r\n\r\n.mr-pagination-controls {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.mr-count {\r\n  font-size: 0.75rem;\r\n  color: #9e8878;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* ── Table wrapper ── */\r\n.mr-table-wrap {\r\n  overflow-x: auto;\r\n  border-radius: 12px;\r\n  border: 1px solid rgba(109, 78, 54, 0.13);\r\n  background: #fff;\r\n  box-shadow: 0 2px 10px rgba(0,0,0,0.04);\r\n}\r\n\r\n/* ── Table ── */\r\n.mr-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  font-size: 0.82rem;\r\n}\r\n\r\n.mr-th {\r\n  background: #f9f7f3;\r\n  color: #6d4e36;\r\n  font-weight: 700;\r\n  font-size: 0.72rem;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.04em;\r\n  padding: 10px 10px;\r\n  border-bottom: 2px solid rgba(109, 78, 54, 0.12);\r\n  cursor: pointer;\r\n  white-space: nowrap;\r\n  user-select: none;\r\n  transition: background 0.15s;\r\n}\r\n\r\n.mr-th:hover { background: #f0ece4; }\r\n.mr-th-active { background: #ede8df !important; }\r\n.mr-th-exp { width: 24px; padding: 10px 6px; }\r\n.mr-sort-arrow { font-size: 0.65rem; opacity: 0.5; }\r\n\r\n.mr-table td {\r\n  padding: 9px 10px;\r\n  border-bottom: 1px solid rgba(109, 78, 54, 0.07);\r\n  vertical-align: middle;\r\n}\r\n\r\n.mr-row {\r\n  cursor: pointer;\r\n  transition: background 0.12s;\r\n}\r\n\r\n.mr-row:hover { background: #faf8f4; }\r\n.mr-row-expanded { background: #f5f2ec !important; }\r\n\r\n.mr-td-exp {\r\n  color: #b0a090;\r\n  text-align: center;\r\n  width: 24px;\r\n}\r\n\r\n.mr-td-muted { color: #9e8878; font-size: 0.78rem; }\r\n.mr-td-num { text-align: right; font-variant-numeric: tabular-nums; }\r\n\r\n/* Matériel cell */\r\n.mr-mat-cell {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.mr-mat-id {\r\n  font-size: 0.68rem;\r\n  font-weight: 700;\r\n  color: #b0a090;\r\n  background: rgba(109, 78, 54, 0.07);\r\n  border-radius: 4px;\r\n  padding: 1px 5px;\r\n}\r\n\r\n.mr-mat-matricule {\r\n  font-weight: 800;\r\n  color: #3d2b1f;\r\n  font-size: 0.82rem;\r\n}\r\n\r\n.mr-mat-type {\r\n  font-size: 0.62rem !important;\r\n  padding: 1px 5px !important;\r\n}\r\n\r\n.mr-mat-soc {\r\n  font-size: 0.68rem;\r\n  color: #b0a090;\r\n  margin-top: 1px;\r\n}\r\n\r\n/* Ref BDC */\r\n.mr-ref-bdc {\r\n  font-size: 0.73rem;\r\n  font-weight: 700;\r\n  color: #4527a0;\r\n  background: rgba(69, 39, 160, 0.07);\r\n  border-radius: 5px;\r\n  padding: 2px 7px;\r\n}\r\n\r\n/* Fournisseur */\r\n.mr-td-fournisseur {\r\n  font-size: 0.78rem;\r\n  color: #3d2b1f;\r\n  max-width: 150px;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* Designation */\r\n.mr-designation {\r\n  font-weight: 600;\r\n  color: #3d2b1f;\r\n  line-height: 1.3;\r\n}\r\n\r\n.mr-code {\r\n  font-size: 0.67rem;\r\n  color: #b0a090;\r\n  margin-top: 2px;\r\n  font-family: monospace;\r\n}\r\n\r\n.mr-unite {\r\n  font-size: 0.68rem;\r\n  color: #b0a090;\r\n}\r\n\r\n.mr-ttc {\r\n  font-weight: 800;\r\n  color: #1565c0;\r\n}\r\n\r\n/* ── Expanded row ── */\r\n.mr-row-detail td {\r\n  padding: 0 !important;\r\n  background: #f8f6f1;\r\n}\r\n\r\n.mr-expand {\r\n  padding: 14px 18px 16px;\r\n  border-bottom: 2px solid rgba(109, 78, 54, 0.1);\r\n}\r\n\r\n.mr-expand-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\r\n  gap: 12px;\r\n}\r\n\r\n.mr-expand-section {\r\n  background: #fff;\r\n  border-radius: 10px;\r\n  border: 1px solid rgba(109, 78, 54, 0.1);\r\n  padding: 10px 12px;\r\n}\r\n\r\n.mr-expand-comment {\r\n  grid-column: 1 / -1;\r\n}\r\n\r\n.mr-expand-title {\r\n  font-size: 0.67rem;\r\n  font-weight: 700;\r\n  color: #9e8878;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.06em;\r\n  margin-bottom: 8px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n}\r\n\r\n.mr-expand-rows {\r\n  display: grid;\r\n  grid-template-columns: auto 1fr;\r\n  gap: 4px 10px;\r\n  align-items: start;\r\n}\r\n\r\n.mr-exp-label {\r\n  font-size: 0.7rem;\r\n  color: #b0a090;\r\n  white-space: nowrap;\r\n  padding-top: 1px;\r\n}\r\n\r\n.mr-exp-val {\r\n  font-size: 0.78rem;\r\n  font-weight: 600;\r\n  color: #3d2b1f;\r\n  word-break: break-word;\r\n}\r\n\r\n.mr-exp-comment-body {\r\n  font-size: 0.78rem;\r\n  color: #5a4a3a;\r\n  line-height: 1.5;\r\n  white-space: pre-wrap;\r\n}\r\n\r\n/* ── Footer total ── */\r\n.mr-foot td {\r\n  background: #f5f2ec;\r\n  border-top: 2px solid rgba(109, 78, 54, 0.15);\r\n  border-bottom: none;\r\n}\r\n\r\n.mr-foot-label {\r\n  font-size: 0.72rem;\r\n  font-weight: 700;\r\n  color: #9e8878;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.04em;\r\n}\r\n\r\n.mr-foot-ttc {\r\n  font-size: 0.92rem;\r\n  font-weight: 900;\r\n  color: #1565c0;\r\n  text-align: right;\r\n}\r\n\r\n/* ── Empty state ── */\r\n.mr-empty {\r\n  text-align: center;\r\n  padding: 3rem;\r\n  color: #b0a090;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n/* ── Pagination ── */\r\n.mr-pager {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 5px;\r\n  margin-top: 16px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.mr-pg-btn {\r\n  min-width: 32px;\r\n  height: 32px;\r\n  padding: 0 8px;\r\n  border: 1.5px solid rgba(109, 78, 54, 0.18);\r\n  border-radius: 8px;\r\n  background: #fff;\r\n  color: #6d4e36;\r\n  font-size: 0.8rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.15s;\r\n}\r\n\r\n.mr-pg-btn:hover:not(:disabled) {\r\n  background: #f5f0e8;\r\n  border-color: rgba(109, 78, 54, 0.35);\r\n}\r\n\r\n.mr-pg-btn:disabled {\r\n  opacity: 0.35;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.mr-pg-active {\r\n  background: #6d4e36 !important;\r\n  color: #fff !important;\r\n  border-color: #6d4e36 !important;\r\n  font-weight: 800 !important;\r\n}\r\n\r\n.mr-pg-ellipsis {\r\n  color: #b0a090;\r\n  padding: 0 4px;\r\n  font-size: 0.82rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
